import { useAppSelector } from '../store'

export function useAnalyticsSettings() {
  return useAppSelector(state => state.analyticsSettings)
}
